import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackageInsuranceMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  insuranceId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackageInsuranceMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackageInsurance'>
);


export const DeletePackageInsuranceDocument = /*#__PURE__*/ gql`
    mutation deletePackageInsurance($packageId: String!, $insuranceId: String!) {
  deletePackageInsurance(packageId: $packageId, insuranceId: $insuranceId)
}
    `;

/**
 * __useDeletePackageInsuranceMutation__
 *
 * To run a mutation, you first call `useDeletePackageInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageInsuranceMutation, { data, loading, error }] = useDeletePackageInsuranceMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      insuranceId: // value for 'insuranceId'
 *   },
 * });
 */
export function useDeletePackageInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageInsuranceMutationResult, DeletePackageInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageInsuranceMutationResult, DeletePackageInsuranceMutationVariables>(DeletePackageInsuranceDocument, options);
      }
export type DeletePackageInsuranceMutationHookResult = ReturnType<typeof useDeletePackageInsuranceMutation>;